import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UTMdataFilter } from "../../../../helper";
import { fetchGraphUTMContent } from "./utmContentAPI";

const initialState = {
  status: "idle",
  error: null,
  data: {},
  visitors: [],
  percentBooking: [],
  percentBought: [],
  weeks: [],
  labels: [],
};

export const graphUTMContent = createAsyncThunk(
  "utmContent/visitors",
  async (user, { rejectWithValue }) => {
    try {
      const dbpath = `${user}/graph-utm_content`;
      const response = await fetchGraphUTMContent(dbpath, user, 'graph-utm_content');
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const utmContentSlice = createSlice({
  name: "utmContent",
  initialState,
  reducers: {
    resetutmContent: (state, action) => {
      return { ...initialState };
    },
    setUniqueEngaged: (state, action) => {
      state.uniqueEngaged = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(graphUTMContent.pending, (state) => {
        state.status = "loading";
      })
      .addCase(graphUTMContent.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
        const result = action.payload;
        // console.log(result);
        try {
          state.data = result;
          const resultData = utmContentHandler(result, "utm_content=");
          state.visitors = resultData.visitors.reverse();
          state.percentBooking = resultData.percentBooking.reverse();
          state.percentBought = resultData.percentBought.reverse();
          state.weeks = resultData.weeks.reverse();
          state.labels = resultData.labels.reverse();
        } catch (error) {
          // console.warn("UTMContent data not found!", error)
        }

      })
      .addCase(graphUTMContent.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      });
  },
});

export const {resetutmContent} = utmContentSlice.actions;


export const SelectVisitors = (state) => state.utmContent.visitors;
export const SelectPercentBooking = (state) => state.utmContent.percentBooking;
export const SelectPercentBought = (state) => state.utmContent.percentBought;
export const SelectLabels = (state) => state.utmContent.labels;
export const SelectWeeks = (state) => state.utmContent.weeks;
export const SelectUTMContentStatus = (state) => state.utmContent.status;

export default utmContentSlice.reducer;

export const utmContentHandler = (data, utmParam) => {
  let resultObj = {
    weeks: [],
    visitors: [],
    percentBooking: [],
    percentBought: [],
    labels: [],
  };

  const resultData =  UTMdataFilter(data, resultObj, utmParam);
  return resultData;
};

